export default {
  submenu: 'Submenu:',
  content: 'Inhoud',
  overview: 'Overzicht',
  longTermSupport: 'Langdurige ondersteuning',
  skillsAndTalents: 'Vaardigheden en Talenten',
  yourMap: 'Uw kaart',
  motivationAndEmotionalIntelligence: 'Motivatie en Emotionele Intelligentie',
  alliancesCompromisesAndResources: 'Allianties, compromissen en resources',
  skillsToStartABusiness: 'Vaardigheden om meen bedrijf te starten',
  accountingAndFinance: 'Boekhouding en Financiën',
  settingUpYourOwnBusiness: 'Je eigen bedrijf opzetten',
  accountingBasics: 'Basiskennis boekhouden',
  openingABankAccount: 'Een bankrekening openen',
  businessPlanBasicInformation: 'Business Plan, basisinformatie',
  taxes: 'Belastingen',
  legalFormsOfEmployment: 'Wettelijke regelgeving voor ondernemerschap',
  marketingAndSales: 'Marketing & Sales',
  whatAreMyProducts: 'Wat zijn mijn producten?',
  whoAreMyClients: 'Wat zijn mijn cliënten?',
  communication: 'Communicatie',
  positioning: 'Positionering',
  sales: 'Sales',
  uniqueSellingPoints: 'Unique Selling Points',
  publicRelations: 'Public Relations',
  introduction: 'Introductie',
  strategy: 'Strategie',
  messagesAndTools: 'Berichten en Instrumenten',
  digitalPRAndSMRevolution: 'Digitale PR en social media revolutie',
  it: 'ICT',
  cloudVSOnPremises: 'Cloud vs. On-Premises',
  email: 'Email',
  onlineMarketing: 'Online Marketing',
  webshop: 'Webshop',
  website: 'Website'
}



// WEBPACK FOOTER //
// ./src/i18n/contentnav/nl.js